window.addEventListener("DOMContentLoaded", () => {
  const selectors = {
    slider: '.wrapper__reviews--js'
  };

  desktopSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.131,
          slidesToScroll: 1
        }
      }
    ]
  };

  function initSliders() {
    $(selectors.slider).not('.slick-initialized').slick(desktopSliderSettings);
  };

  setTimeout(() => {
    initSliders();
  }, 500);

  window.addEventListener('resize', initSliders);  
});